import { connect } from 'react-redux';
import { setIsNavHidden } from 'navigation/navigationSlice';
import Create from './Create';

const mapState = state => ({
  isNavHidden: state.navigation.isNavHidden,
});

const mapDispatch = {
  setIsNavHidden,
};

export default connect(mapState, mapDispatch)(Create);
